export default "__VITE_ASSET__BwNQB2ej__"